// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2lnEbbphk_09bqQJpvXqhR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChartWrapper/ChartWrapper.scss
// module id = 1251
// module chunks = 1